import * as React from "react";
import { PropertyWhatsAround as SharedUiPropertyWhatsAround } from "@shared-ui/lodging-property-details";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { RefTarget } from "@shared-ui/ref-context";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyWhatsAround = PropertyBexApiWrapper(SharedUiPropertyWhatsAround);

export const PropertyWhatsAround: React.FC<ComponentProps> = ({ context, flexTemplateNode }) => {
  return (
    <UitkSpacing margin={{ block: "three" }}>
      <RefTarget name="Location" tag="section">
        <WrappedPropertyWhatsAround context={context} />
      </RefTarget>
    </UitkSpacing>
  );
};
export default PropertyWhatsAround;
